import {UIGameVerticalMovementAnimation} from '../ui_canvas_engine/UIGameVerticalMovementAnimation'
import {CardView} from '../ui_canvas_engine/CardView'
import {UIGameManager} from '../ui_game/UIGameManager'
import {UIGameAnimationBase} from '../ui_canvas_engine/animation/UIGameAnimationBase'
import {CardEnum} from '@colonist/game-states'

export class UIGameTradeBeginnerCardAnimationsController {
    private readonly uiGameManager: UIGameManager
    private readonly allCardViews: CardView[]
    private readonly cardEnumToAnimations: Map<CardEnum, UIGameAnimationBase[]> = new Map()
    cardEnumsForBeginnerCardAnimation: CardEnum[] = []
    private pausedCardEnumsForBeginnerCardAnimation: CardEnum[] = []

    constructor(uiGameManager: UIGameManager, allCardViews: CardView[]) {
        this.uiGameManager = uiGameManager
        this.allCardViews = allCardViews
    }

    stopBeginnerAnimation() {
        const cardEnums = [...new Set(this.cardEnumsForBeginnerCardAnimation)]
        for(const cardEnum of cardEnums) this.cardEnumToAnimations.get(cardEnum)?.forEach((animation: UIGameAnimationBase) => animation.stop())

        this.cardEnumsForBeginnerCardAnimation = []
        this.pausedCardEnumsForBeginnerCardAnimation = []
    }

    private pauseAnimationBecauseCardIsSelected(cardEnum: CardEnum): boolean {
        const countOfCardsPaused = this.pausedCardEnumsForBeginnerCardAnimation.reduce((acc, currentCardEnum) => currentCardEnum == cardEnum ? acc + 1 : acc, 0)
        const countOfCardsToBeAnimated = this.cardEnumsForBeginnerCardAnimation.reduce((acc, currentCardEnum) => currentCardEnum == cardEnum ? acc + 1 : acc, 0)
        if(countOfCardsPaused >= countOfCardsToBeAnimated) return true
        return false
    }

    startBeginnerAnimation(cardsToAnimate: CardEnum[]) {
        this.setCardAnimations()
        this.cardEnumsForBeginnerCardAnimation = []
        for(const card of cardsToAnimate) this.cardEnumsForBeginnerCardAnimation.push(card)

        this.animateOrPauseCards(this.cardEnumsForBeginnerCardAnimation)
    }

    updateCardsForBeginnerAnimation(cardsOnCurrentTrade: CardEnum[]): boolean {
        this.pausedCardEnumsForBeginnerCardAnimation = []
        for(const cardEnum of cardsOnCurrentTrade) {
            if(!this.cardEnumsForBeginnerCardAnimation.includes(cardEnum)) continue
            this.pausedCardEnumsForBeginnerCardAnimation.push(cardEnum)
        }
        this.animateOrPauseCards(this.cardEnumsForBeginnerCardAnimation)
        return UIGameTradeBeginnerCardAnimationsController.areSameCards(cardsOnCurrentTrade, this.cardEnumsForBeginnerCardAnimation)
    }

    addCardToBeginnerCardAnimations(card: CardView) {
        if(this.allCardViews.length == 0) return

        const maxAnimationDistance = this.allCardViews[0].height * 0.1
        const animations = this.cardEnumToAnimations.get(card.cardData.cardEnum) ?? []
        animations.push(new UIGameVerticalMovementAnimation(card, maxAnimationDistance))
        this.cardEnumToAnimations.set(card.cardData.cardEnum, animations)
        this.startBeginnerAnimation(this.cardEnumsForBeginnerCardAnimation)
    }

    private setCardAnimations() {
        for(const cardEnum of this.cardEnumToAnimations.keys()) this.cardEnumToAnimations.get(cardEnum)?.forEach((animation: UIGameAnimationBase) => animation.stop())
        this.cardEnumToAnimations.clear()

        if(this.allCardViews.length == 0) return

        const maxAnimationDistance = this.allCardViews[0].height * 0.1
        for(const card of this.allCardViews) {
            const cardEnum = card.cardData.cardEnum
            const animations = this.cardEnumToAnimations.get(cardEnum) ?? []
            animations.push(new UIGameVerticalMovementAnimation(card, maxAnimationDistance))
            this.cardEnumToAnimations.set(cardEnum, animations)
        }
    }

    private static areSameCards(cards1: CardEnum[], cards2: CardEnum[]): boolean {
        if(cards1.length != cards2.length) return false

        const cards1Sorted = cards1.sort()
        const cards2Sorted = cards2.sort()
        for(const [index, card1] of cards1Sorted.entries()) {
            if(card1 != cards2Sorted[index]) return false
        }
        return true
    }

    private animateOrPauseCards(cardsToAnimate: CardEnum[]) {
        const distinctCardEnums = [...new Set(cardsToAnimate)]
        for(const cardEnum of distinctCardEnums) {
            if(this.pauseAnimationBecauseCardIsSelected(cardEnum)) this.cardEnumToAnimations.get(cardEnum)?.forEach((animation: UIGameAnimationBase) => animation.stop())
            else this.cardEnumToAnimations.get(cardEnum)?.forEach((animation: UIGameAnimationBase) => animation.start())
        }
    }
}
